import {useQuery} from '@tanstack/react-query';
import {Select,Space} from 'antd';
import {getAccessMe} from '../accessApi';
import {request} from '../api';
import {selectedProject,saveSelectedProject} from '../projectSelection';

export default function ProjectSwitcher(){
 const mode=useQuery({queryKey:['access-mode'],queryFn:()=>request<{project_access_enabled:boolean}>('/api/v1/platform/access-mode'),retry:false});
 const me=useQuery({queryKey:['access-me'],queryFn:getAccessMe,enabled:mode.data?.project_access_enabled===true,retry:false});
 if(!mode.data?.project_access_enabled)return null;
 const selected=selectedProject(me.data?.user_id)??'';
 const projects=me.data?.projects??[];
 const missing=selected&&!projects.some(p=>p.id===selected);
 return <Space size="small"><span>项目</span><Select aria-label="当前项目" style={{minWidth:180,maxWidth:280}} disabled={!me.data||!!me.error} loading={me.isPending} value={selected}
  options={[{value:'',label:'全部有权访问的项目'},...projects.map(p=>({value:p.id,label:p.name})),...(missing?[{value:selected,label:'所选项目权限已失效',disabled:true}]:[])]}
  onChange={value=>{if(me.data){saveSelectedProject(me.data.user_id,value);window.location.assign('/runs');}}}/></Space>;
}
